import type { PaymentMethod } from 'types/delivery.types';

const METHODS: { value: PaymentMethod; label: string; desc: string; icon: string }[] = [
    { value: 'card',   label: 'Card Payment',        desc: 'Debit or credit card',    icon: 'credit_card' },
    { value: 'cash',   label: 'Cash on Delivery',    desc: 'Pay when delivered',      icon: 'payments' },
    { value: 'wallet', label: 'Wallet',               desc: 'Pay from your balance',   icon: 'account_balance_wallet' },
];

interface Props {
    selected: PaymentMethod;
    onChange: (value: PaymentMethod) => void;
}

const PaymentMethods = ({ selected, onChange }: Props) => {
    return (
        <div className="space-y-2">
            {METHODS.map((method) => (
                <button
                    key={method.value}
                    type="button"
                    onClick={() => onChange(method.value)}
                    className={`w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl border-2 transition-all text-left ${
                        selected === method.value
                            ? 'border-primary bg-primary/5 shadow-sm shadow-primary/10'
                            : 'border-slate-100 bg-white hover:border-slate-200'
                    }`}
                >
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${
                        selected === method.value ? 'bg-primary text-white' : 'bg-slate-100 text-slate-500'
                    }`}>
                        <span
                            className="material-symbols-outlined text-[20px]"
                            style={{ fontVariationSettings: '"FILL" 1' }}
                        >
                            {method.icon}
                        </span>
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-black text-slate-800">{method.label}</p>
                        <p className="text-xs text-slate-400">{method.desc}</p>
                    </div>
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                        selected === method.value ? 'border-primary' : 'border-slate-300'
                    }`}>
                        {selected === method.value && (
                            <div className="w-2.5 h-2.5 rounded-full bg-primary" />
                        )}
                    </div>
                </button>
            ))}
        </div>
    );
};

export default PaymentMethods